import React from 'react'
import { getCodeTranslate, IconComponent, IconProps, UISizes, UITypes } from 'LibNeo'
import { Popconfirm } from 'antd'
import { PopconfirmProps } from 'antd/lib/popconfirm'

export const getTitle = (
	title?: string | JSX.Element,
	titleCode?: string
): string | JSX.Element => {
	const defaultTitle = title || ''
	return titleCode ? getCodeTranslate(titleCode) : defaultTitle
}

export const getIcon = (options: IconProps): JSX.Element => {
	const { name, type, size, disabled, tooltip } = options
	if (!name) return null
	return <IconComponent tooltip={tooltip} name={name} type={type} size={size} disabled={disabled} />
}

export const getSizeClass = (baseClass: string, size: UISizes): string => {
	switch (size) {
		case UISizes.SMALL:
			return `${baseClass}--small`
		case UISizes.NORMAL:
			return `${baseClass}--normal`
		case UISizes.BIG:
			return `${baseClass}--big`

		default:
			return `${baseClass}--normal`
	}
}

export const getTypeClass = (baseClass: string, type: UITypes): string => {
	switch (type) {
		case UITypes.MAIN:
			return `${baseClass}--main`
		case UITypes.PRIMARY:
			return `${baseClass}--primary`
		case UITypes.WARNING:
			return `${baseClass}--warning`
		case UITypes.DANGER:
			return `${baseClass}--danger`
		case UITypes.PASSIVE:
			return `${baseClass}--passive`
		case UITypes.BLUE:
			return `${baseClass}--blue`
		case UITypes.SUCCESS:
			return `${baseClass}--success`
		default:
			return `${baseClass}--primary`
	}
}

export const getPopConfirm = (
	elem: JSX.Element,
	popConfirmProps: PopconfirmProps,
	disabled = false
): JSX.Element => {
	if (popConfirmProps && !disabled) {
		return <Popconfirm {...popConfirmProps}>{elem}</Popconfirm>
	}
	return elem
}

export const isWinOs = () => window.navigator.appVersion.includes('Win')
